module.exports = __webpack_public_path__ + "media/images/rema-3-3fea75572bd8c7679b4b58c99d8bad40.jpg";